import React, { Component } from 'react';
import JejakinLogo from './../../../gogreener_carbon_offset_jejakin.svg';
import './Header.scss'

class Header extends Component {
   state = {
      loggedIn: false,
      isAuth : null,
      companyName : null,
      initialName : 'J',
      hexaColor : 'c8d6e5',
      dropdownAcc : false
   }

   componentDidMount(){
     
   }

   render(){
      return (
         <div className="header no-print">
            <div className="nav nav-main-top">
               <div className="container">
                  <div className="row">
                     <div className="col-sm-12">
                        <div className="logo-img">
                           <a href="/">
                           <img src={JejakinLogo} alt="Jejak.in"/>
                           </a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      )
   }
}
export default Header
